export default __webpack_public_path__ + "static/media/PainLow.821a3f14.svg";